module.exports = __webpack_public_path__ + "static/img/logo.3318247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sack/logo.png
// module id = zIDU
// module chunks = 1